import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
export interface AppheaderUserInfo {
  fullName: string;
  email: string;
  role: string
}
/*
TODO: According to the styleguide following stuff is missing:
- Styling is not totally correct --> e.g. rem-units missing, application textname no size given
- Tokenmechanism --> icon, counter, outputevent
- Notification
- Appswitcher
- Dark/light theme --> boolean from outside?
*/
@Component({
  selector: 'avano-appheader',
  templateUrl: './avano-appheader.component.html',
  styleUrls: ['./avano-appheader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoAppheaderComponent {
  readonly templateTypes: {
    userPopoverUserInfoData: {$implicit: AppheaderUserInfo}
  }
  @ViewChild('userPopoverUserInfo') userPopoverUserInfo: TemplateRef<unknown>;
  @Input() systemRibbonText: string;

  @Input() userName: string;
  @Input() userOrg: string;
  @Input() userPopoverTemplate: TemplateRef<unknown>;

  // The common avano appHeader component is used on error pages too, but then without any interaction
  @Input() isOnErrorPage: boolean;
}
